import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface HallFilterState {
  hallInfo: { hallName: string; partnerId: number | null };
  months: string[];
  dates: { startDate: string; endDate: string };
  times: string[];
  dayOfWeeks: string[];
  region: { region: string; subRegion: string };
}

const initialState: HallFilterState = {
	hallInfo: { hallName: '', partnerId: null },
	months: [],
	dates: { startDate: '', endDate: '' },
	times: [],
	dayOfWeeks: [],
	region: { region: '', subRegion: '' },
};


const hallFilterSlice = createSlice({
  name: 'hallFilter',
  initialState,
  reducers: {
    setHallInfo(state, action: PayloadAction<{ hallName: string; partnerId: number | null }>) {
      state.hallInfo = action.payload;
    },
    setMonths(state, action: PayloadAction<string[]>) {
      state.months = action.payload;
    },
    setDates(state, action: PayloadAction<{ startDate: string; endDate: string }>) {
      state.dates = action.payload;
    },
    setTimes(state, action: PayloadAction<string[]>) {
      state.times = action.payload;
    },
    setDayOfWeeks(state, action: PayloadAction<string[]>) {
      state.dayOfWeeks = action.payload;
    },
    setRegion(state, action: PayloadAction<{ region: string; subRegion: string }>) {
      state.region = action.payload;
    }
  },
});

export const {
  setHallInfo,
  setMonths,
  setDates,
  setTimes,
  setDayOfWeeks,
  setRegion
} = hallFilterSlice.actions;

export default hallFilterSlice.reducer;